import { JSX } from 'preact/compat'

type Props = {
  children: JSX.Element
}

const ThankYou = (props: Props) => (
  <div className="wf_reset wf_container wf_thankyou_wrapper">
    <div className="wf_reset wf_box wf_thankyou_box">{props.children}</div>
  </div>
)

export default ThankYou
